const ENGINE_RULES: { test: RegExp; name: string; keys: string[] }[] = [
  { test: /baidu\./i, name: '百度', keys: ['wd', 'word'] },
  { test: /so\.com|360\./i, name: '360', keys: ['q'] },
  { test: /sogou\./i, name: '搜狗', keys: ['query', 'keyword'] },
  { test: /sm\.cn|shenma/i, name: '神马', keys: ['q'] },
  { test: /google\./i, name: '谷歌', keys: ['q'] },
  { test: /bing\./i, name: '必应', keys: ['q'] },
  { test: /yahoo\./i, name: '雅虎', keys: ['p', 'q'] },
];

const SPIDER_RULES: { test: RegExp; name: string }[] = [
  { test: /Baiduspider/i, name: '百度蜘蛛' },
  { test: /Googlebot/i, name: 'Google 蜘蛛' },
  { test: /360Spider/i, name: '360 蜘蛛' },
  { test: /Sogou\s*(web\s*)?spider/i, name: '搜狗蜘蛛' },
  { test: /bingbot|BingPreview/i, name: '必应蜘蛛' },
  { test: /Bytespider/i, name: '头条蜘蛛' },
  { test: /YisouSpider/i, name: '神马蜘蛛' },
  { test: /YandexBot/i, name: 'Yandex 蜘蛛' },
  { test: /DuckDuckBot/i, name: 'DuckDuckGo 蜘蛛' },
  { test: /spider|crawler|bot/i, name: '其他蜘蛛' },
];

const CITY_PROVINCE: Record<string, string> = {
  北京: '北京',
  上海: '上海',
  天津: '天津',
  重庆: '重庆',
  广州: '广东',
  深圳: '广东',
  东莞: '广东',
  佛山: '广东',
  杭州: '浙江',
  宁波: '浙江',
  南京: '江苏',
  苏州: '江苏',
  成都: '四川',
  武汉: '湖北',
  西安: '陕西',
  郑州: '河南',
  长沙: '湖南',
  青岛: '山东',
  合肥: '安徽',
  福州: '福建',
  厦门: '福建',
  哈尔滨: '黑龙江',
  香港: '香港',
  台北: '台湾',
};

const SOCIAL_RULES: { test: RegExp; name: string }[] = [
  { test: /weibo\./i, name: '微博' },
  { test: /weixin\.|mp\.weixin/i, name: '微信' },
  { test: /zhihu\./i, name: '知乎' },
  { test: /xiaohongshu\./i, name: '小红书' },
  { test: /douyin\.|tiktok\./i, name: '抖音 / TikTok' },
  { test: /bilibili\./i, name: '哔哩哔哩' },
  { test: /qzone\.qq/i, name: 'QQ 空间' },
  { test: /twitter\.|x\.com/i, name: 'X / Twitter' },
  { test: /facebook\./i, name: 'Facebook' },
  { test: /instagram\./i, name: 'Instagram' },
  { test: /linkedin\./i, name: 'LinkedIn' },
  { test: /reddit\./i, name: 'Reddit' },
];

export function socialName(referrer: string): string {
  const host = referrerHost(referrer);
  return SOCIAL_RULES.find((r) => r.test.test(host))?.name || host || '其他社交';
}

export function referrerHost(referrer: string): string {
  if (!referrer) return '';
  try {
    return new URL(referrer).hostname.replace(/^www\./, '');
  } catch {
    return referrer;
  }
}

const PAGE_KEYWORD_KEYS = ['utm_term', 'wd', 'word', 'q', 'query', 'keyword'];

function keywordFromParams(params: URLSearchParams, keys: string[]): string {
  return keys.map((k) => params.get(k) || '').find(Boolean) || '';
}

function parseUrlSafe(value: string): URL | null {
  if (!value) return null;
  try {
    return /^https?:\/\//i.test(value) ? new URL(value) : new URL(value, 'https://example.com');
  } catch {
    return null;
  }
}

export function parseSearch(referrer: string, pageUrl?: string): { engine: string; keyword: string } {
  let engine = '';
  let keyword = '';
  const ref = parseUrlSafe(referrer);
  if (ref) {
    const rule = ENGINE_RULES.find((r) => r.test.test(ref.hostname));
    if (rule) {
      engine = rule.name;
      keyword = keywordFromParams(ref.searchParams, rule.keys);
    }
  }
  if (!keyword && pageUrl) {
    const page = parseUrlSafe(pageUrl);
    if (page) keyword = keywordFromParams(page.searchParams, PAGE_KEYWORD_KEYS);
  }
  return { engine, keyword: keyword ? decodeMaybe(keyword) : '' };
}

function decodeMaybe(value: string): string {
  try {
    return decodeURIComponent(value.replace(/\+/g, ' '));
  } catch {
    return value;
  }
}

export function detectSpider(ua: string): string {
  if (!ua) return '';
  const hit = SPIDER_RULES.find((r) => r.test.test(ua));
  return hit?.name || '';
}

export function isSpider(ua: string): boolean {
  return Boolean(detectSpider(ua));
}

export function inferIsp(_ip: string, hint?: string): string {
  if (hint && hint !== '0') return hint;
  return '未知';
}

export function cityToProvince(city: string, country?: string, province?: string): string {
  const stored = (province || '').replace(/[省市自治区特别行政区]$/, '');
  if (stored && stored !== '0') return stored;
  const raw = (city || '').replace(/[市区县]$/, '');
  if (CITY_PROVINCE[city] || CITY_PROVINCE[raw]) return CITY_PROVINCE[city] || CITY_PROVINCE[raw];
  if (city.endsWith('省')) return city.slice(0, -1);
  if (['内蒙古', '新疆', '西藏', '广西', '宁夏', '香港', '澳门', '台湾'].includes(raw)) return raw;
  if (country && country !== '中国') return country;
  return raw || '未知';
}
